<template>
    <DefaultField
        :field="currentField"
        :errors="errors"
        :full-width-content="mode === 'modal'"
        :show-help-text="showHelpText"
    >
        <template #field>
            <FormValueListTable
                :edit-mode="!currentlyIsReadonly"
                :can-delete-row="currentField.canDeleteRow"
            >
                <FormValueListHeader
                    :value-label="currentField.valueLabel"
                />

                <div class="bg-white dark:bg-gray-800 overflow-hidden value-list-items">
                    <FormValueListItem
                        v-for="(item, index) in theData"
                        :index="index"
                        @remove-row="removeRow"
                        :item.sync="item"
                        :key="item.id"
                        :ref="item.id"
                        :read-only="currentlyIsReadonly"
                        :can-delete-row="currentField.canDeleteRow"
                    />
                </div>
            </FormValueListTable>

            <div
                class="mr-11"
                v-if="
          !currentlyIsReadonly &&
          currentField.canAddRow
        "
            >
                <button
                    @click="addRowAndSelect"
                    :dusk="`${field.attribute}-add-value-list`"
                    type="button"
                    class="cursor-pointer focus:outline-none focus:ring ring-primary-200 dark:ring-gray-600 focus:ring-offset-4 dark:focus:ring-offset-gray-800 rounded-lg mx-auto text-primary-500 font-bold link-default mt-3 px-3 rounded-b-lg flex items-center"
                >
                    <Icon type="plus-circle" />
                    <span class="ml-1">{{ currentField.actionText }}</span>
                </button>
            </div>
        </template>
    </DefaultField>
</template>

<script>
import findIndex from 'lodash/findIndex'
import filter from 'lodash/filter'
import map from 'lodash/map'
import tap from 'lodash/tap'
import { DependentFormField, HandlesValidationErrors } from '@/mixins'
import DefaultField from "@/components/DefaultField.vue";
import fromPairs from "lodash/fromPairs";
import reject from "lodash/reject";

function guid() {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return (
        S4() +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        S4() +
        S4()
    )
}

export default {
    components: {DefaultField},
    mixins: [HandlesValidationErrors, DependentFormField],

    data: () => ({ theData: [] }),

    mounted() {
        this.populateValueListData()
    },

    methods: {
        /*
         * Set the initial value for the field
         */
        populateValueListData() {
            this.theData = map(this.value || [], (value) => ({
                id: guid(),
                value,
            }))

            if (this.theData.length == 0) {
                this.addRow()
            }
            console.log('valuelistfield: populateValueListData: ' + JSON.stringify(this.theData))

        },

        /**
         * Provide a function that fills a passed FormData object with the
         * field's internal value attribute.
         */
        fill(formData) {
            console.log('valuelistfield: fill: ' + JSON.stringify(this.formData))
            this.fillIfVisible(
                formData,
                this.field.attribute,
                JSON.stringify(this.finalPayload)
            )
        },

        /**
         * Add a row to the table.
         */
        addRow() {
            console.log('valuelistfield: addRow: ' + JSON.stringify(this.theData))
            return tap(guid(), id => {
                this.theData = [...this.theData, { id, value: '' }]
                return id
            })
        },

        /**
         * Add a row to the table and select its first field.
         */
        addRowAndSelect() {
            return this.selectRow(this.addRow())
        },

        /**
         * Remove the row from the table.
         */
        removeRow(id) {
            console.log('valuelistfield: removeRow: ' + JSON.stringify(this.theData))
            return tap(
                findIndex(this.theData, row => row.id == id),
                index => this.theData.splice(index, 1)
            )
        },

        /**
         * Select the first field in a row with the given ref ID.
         */
        selectRow(refId) {
            return this.$nextTick(() => {
                this.$refs[refId][0].handleKeyFieldFocus()
            })
        },

        onSyncedField() {
            this.populateValueListData()
        },
    },

    computed: {
        /**
         * Return the final filtered json object
         */
        finalPayload() {
            let result =filter(map(this.theData, 'value'))
            console.log('valuelistfield: finalPayload: ' + JSON.stringify(result))
            return result
        },
        // return fromPairs(
        //     reject(
        //         map(this.theData, row =>
        //             row && row.key ? [row.key, row.value] : undefined
        //         ),
        //         row => row === undefined
        //     )
        // )
    },
}
</script>
